import React, { useState, useEffect, useRef } from 'react';
import { Text, Icon, Button } from 'porosys-ui';
import { useHistory } from 'react-router-dom';
import ActionList from '../../Action/list/ActionList';
import PolicyList from '../../Policy/list/PolicyList';
import CommentsList from '../../Comment/list/CommentsList';
import MeetingForm from '../form/MeetingForm';
import { authorizeUser } from '../../Login/api';
import { getMeeting, publishSummaryForm, approveSummaryForm, revertSummaryForm } from '../api';
import handleSeprateArrayContents from '../../../common/utils/print-array-contents';
import handlePrintStartEndTimeOfMetting from '../../../common/helpers/print-meeting-time-range';
import CustomConfirmation from '../../../common/ui/components/CustomConfirmation/CustomConfirmation';
import '../styles.scss';

const MeetingProfile = props => {
    const { openForm, match } = props;
    const { meetingId } = props.match.params;
    const [logedInUser, setLogedInUser] = useState({});
    const [meeting, setMeeting] = useState(null);
    const [shouldShowForm, setShouldShowForm] = useState(false);
    const [commentMentionedList, setCommentMentionedList] = useState([]);
    const [isPublishSummaryFormConfirmationShowing, setIsPublishSummaryFormConfirmationShowing] = useState(false);
    const [isRevertSummaryFormConfirmationShowing, setIsRevertSummaryFormConfirmationShowing] = useState(false);

    const PolicyListRef = useRef();
    const ActionListRef = useRef();
    const history = useHistory();

    useEffect(() => {
        const fetchLogedInUser = async () => {
            setLogedInUser(await authorizeUser());
        };

        fetchLogedInUser();
    }, []);
    useEffect(() => {
        const fetchMeeting = async () => {
            const fetchedMeeting = await getMeeting(meetingId);
            if (!fetchedMeeting) return;
            setCommentMentionedList(fetchedMeeting.participants.map(participant => participant._id));
            setMeeting(fetchedMeeting);
        };
        fetchMeeting();
    }, [meetingId]);

    const handlePublishSummaryForm = () => {
        const updatedMeeting = { ...meeting, isSummaryFormPublished: true };

        PolicyListRef.current.handlePublishSummaryFormPolicy();
        ActionListRef.current.handlePublishSummaryFormAction();
        setMeeting(updatedMeeting);
        publishSummaryForm(meetingId);
        setIsPublishSummaryFormConfirmationShowing(false);
    };
    const handleRevertSummaryForm = () => {
        const updatedMeeting = { ...meeting, isSummaryFormPublished: false, isUserApproved: false };

        PolicyListRef.current.handleRevertSummaryFormPolicy();
        ActionListRef.current.handleRevertSummaryFormAction();
        setMeeting(updatedMeeting);
        revertSummaryForm(meetingId);
        setIsRevertSummaryFormConfirmationShowing(false);
    };
    const handleApproveSummaryForm = async () => {
        meeting.summaryFormUsersApproves.push(logedInUser._id);
        const updatedMeeting = await approveSummaryForm(meetingId);
        setMeeting({ ...meeting, isUserApproved: true, isSummaryFormApproved: updatedMeeting.isSummaryFormApproved });
    };
    const handleCheckUsersMarkedAsDone = participantId => {
        if (!meeting.summaryFormUsersApproves) return;
        return meeting.summaryFormUsersApproves.indexOf(participantId) > -1;
    };
    const handleToggleMeetingComments = () => {
        history.push(`/meetings/${meetingId}`);
    };
    const handleToggleForm = () => {
        setShouldShowForm(!shouldShowForm);
    };

    const meetingEditForm = (
        <MeetingForm
            handleCancel={() => {
                handleToggleForm();
            }}
            handleUpdateMeeting={updatedMeeting => {
                setMeeting(updatedMeeting);
                handleToggleForm();
            }}
            meetingToEdit={meeting}
        />
    );
    const meetingProfile = meeting && (
        <div className="comments-sidebar-layout ">
            {match && (match.params.actionId || match.params.policyId) && (
                <div onClick={handleToggleMeetingComments} className="unfocused-background" />
            )}

            <div className="content focused">
                <div className="meeting-profile">
                    {shouldShowForm ? (
                        meetingEditForm
                    ) : (
                        <>
                            <div
                                className={`meeting-info ${
                                    match && !match.params.actionId && !match.params.policyId ? 'focused' : ''
                                }`}
                            >
                                <div className="title">
                                    <Text variant="h5" classes={{ root: 'bold' }}>
                                        {meeting.title}
                                    </Text>
                                    <Text variant="subtitle2" classes={{ root: 'text-muted actions-btn' }}>
                                        {meeting.meetingCode}{' '}
                                        {true && (
                                            <button className="btn" onClick={() => handleToggleForm()}>
                                                <Icon fontSize={1} name="pen" />
                                            </button>
                                        )}
                                        <button className="btn" onClick={handleToggleMeetingComments}>
                                            <Icon fontSize={1} name="comments" />
                                        </button>
                                    </Text>
                                </div>
                                <div className="details ">
                                    <Text>{meeting.subject}</Text>
                                    <Text>
                                        <Icon fontSize={1} name="users" />
                                        <span className="participants">
                                            {meeting.participants &&
                                                meeting.participants.map((participant, i) => (
                                                    <span
                                                        className={`single-participant 
                                         ${handleCheckUsersMarkedAsDone(participant._id) ? 'isToggled' : 'notToggled'}`}
                                                        key={i}
                                                    >
                                                        <Icon fontSize={1} name="checkCircle" />
                                                        {participant.fullname}
                                                    </span>
                                                ))}
                                        </span>
                                    </Text>
                                    <Text>
                                        <Icon fontSize={1} name="chalkboardTeacher" />
                                        {meeting.lead && meeting.lead.fullname}
                                    </Text>
                                    <Text>
                                        <Icon fontSize={1} name="clock" />
                                        {handlePrintStartEndTimeOfMetting(meeting.startAt, meeting.endAt)}
                                    </Text>
                                    <Text>
                                        <Icon fontSize={1} name="locationArrow" />
                                        {meeting.location}
                                    </Text>
                                    <Text>
                                        <Icon fontSize={1} name="building" />
                                        {meeting.departments &&
                                            handleSeprateArrayContents('label', meeting.departments)}
                                    </Text>
                                </div>
                            </div>
                            {(meeting.isUserLead || meeting.isSummaryFormPublished) && (
                                <>
                                    <div className="summary-part">
                                        <ActionList
                                            match={match}
                                            showFormOptions={meeting.isSummaryFormPublished ? false : true}
                                            openForm={openForm}
                                            meetingId={meetingId}
                                            ref={ActionListRef}
                                        />
                                        <PolicyList
                                            match={match}
                                            showFormOptions={meeting.isSummaryFormPublished ? false : true}
                                            meetingId={meetingId}
                                            ref={PolicyListRef}
                                        />
                                    </div>
                                    {!meeting.isSummaryFormPublished ? (
                                        <Button
                                            onClick={() => setIsPublishSummaryFormConfirmationShowing(true)}
                                            color="primary"
                                        >
                                            ثبت نهایی
                                        </Button>
                                    ) : (
                                        <>
                                            {meeting.isUserLead && !meeting.isSummaryFormApproved && (
                                                <Button
                                                    onClick={() => setIsRevertSummaryFormConfirmationShowing(true)}
                                                    color="primary"
                                                >
                                                    بازگردانی صورت جلسه
                                                </Button>
                                            )}{' '}
                                            {meeting.isUserParticipant && (
                                                <Button
                                                    disabled={meeting.isUserApproved}
                                                    onClick={() => handleApproveSummaryForm()}
                                                    color="primary"
                                                >
                                                    امضا
                                                </Button>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>

            <div className="comments-sidebar">
                <CommentsList
                    commentParentIndexes={
                        match && (match.params.actionId || match.params.policyId) && { title: 3, id: 4 }
                    }
                    mentionedList={commentMentionedList}
                />
            </div>
            <CustomConfirmation
                onClose={() => {
                    setIsPublishSummaryFormConfirmationShowing(false);
                }}
                onClickOk={() => {
                    handlePublishSummaryForm();
                }}
                operationTitle="ثبت صورت جلسه"
                isOpen={isPublishSummaryFormConfirmationShowing}
            />
            <CustomConfirmation
                onClose={() => {
                    setIsRevertSummaryFormConfirmationShowing(false);
                }}
                onClickOk={() => {
                    handleRevertSummaryForm();
                }}
                operationTitle="بازگردانی صورت جلسه"
                isOpen={isRevertSummaryFormConfirmationShowing}
            />
        </div>
    );

    return meeting ? meetingProfile : 'این جلسه وجود ندارد';
};
export default MeetingProfile;
